const Loading: React.FC = () => {
    return (
      <div className="fixed inset-0 z-50 flex overflow-auto bg-back-shadow h-screen items-center">
        <div className="text-center bg-white px-24 py-12 rounded-lg shadow-lg h-fit mx-auto">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-navy mx-auto mb-4" />
          <p className="text-navy font-medium">Loading...</p>
        </div>
      </div>
    );
  };
  
  export default Loading;